<template>
  <TransactionTemplate
    :getHeaderToolbar="getHeaderToolbar"
    :screenJson="getScreenJson"
    :headerScreenJson="getHeaderScreenJson"
    :setLoading="setLoading"
    :localDataGrid="false"
    :backButtonRoute="getBackButtonRoute()"
    ref="summary-quote-detail"
    :isLoaded="loaded"
    :paging="false"
    v-if="!reload"
    :tabs="{}"
   />
</template>

<script>
import TransactionTemplate from "../../templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      loaded: false,
      reload: false,
      setLoading: false,
      customerName: "",
      formDataModel: {}
    }
  },
  created(){
    this.loaded = true;
    this.customerName = this.baseView.query.CustomerName;
  },
  methods: {
    getBackButtonRoute() {
      return `/sales-order-profit-enquiry/${this.baseView.query.SalesOrderCode}`
    },
    postProcess(data){
      data.forEach((rowData) => {
        rowData.STDCostTotal = rowData.ExTaxUnitCost * rowData.StockUMQty;
        let grossProfitPcnt = ((rowData.NetLineTotal.toFixed(2) - (rowData.ExTaxUnitCost * rowData.StockUMQty).toFixed(2)) / rowData.NetLineTotal.toFixed(2))*100.00;
        rowData.GPPcnt = grossProfitPcnt;
      })

      this.$store.dispatch(
        "dataContext/setReviewDataSource",
        data
      );

      return data;
    }
  },
  computed: {
    getFooterItems(){
      return [
        {
          screenField: "SalesUMItemCount",
          dataField: "SalesUMQty",
          location: "left",
          label: "Item Count",
          value: 0,
        },
        {
          dataField: "TaxableLineTotal",
          screenField: "SalesUMQty",
          location: "right",
          value: 0,
          format: "Decimal-16-2C",
          label: `Sub Total`,
        },
        {
          dataField: "TaxLineTotal",
          screenField: "SalesUMQty",
          location: "right",
          value: 0,
          format: "Decimal-16-2C",
          label: `Tax`,
        },
        {
          dataField: "LineTotal",
          screenField: "NetLineTotal",
          location: "right",
          value: 0,
          format: "Decimal-16-2C",
          label: `Total`,
        },
      ]
    },
    getHeaderToolbar() {
      return {
        headerToolbar: {
          screenName: "Sales Quote Summary",
          pdf: false,
          audit: false,
          status: true,
          notes: false,
          save: false,
          toolbarFormItems: [
            {
              dataField: "CustomerName",
              width: 500,
              label: { text: "Customer Name", visible: false },
              readOnly: true,
              allowEdit: false,
            },
          ],
        }
      }
    },
    getScreenJson() {
      return {
        title: "Sales Quote Detail",
        endpoint: {
          primary: "SalesQuoteSummary",
          filter: `SalesQuoteCode eq ${this.baseView.id}`,
        },
        gridData: {
          gridOptions: {
            dataSource: {
              allowGrouping: false,
              serverPaging: true
            },
            dataGridViews: [
              {
                label: "Details",
                value: "details",
                default: true,
                dataSource: {
                  endpoint: "SalesQuoteDetail",
                  filter: [["SalesQuoteCode", "=", parseInt(this.baseView.id)]],
                  serverPaging: true,
                  allowGrouping: false,
                  postProcessCallback: this.postProcess
                },
                columns: [
                  {
                    screenField: "Item",
                    dataField: "ItemCode",
                    label: "Product/Account",
                    cellTemplateRecord: {
                        primary: [
                          {
                            dataField: "ItemDescn1",
                          },
                        ],
                        secondary: [
                          {
                            dataField: "ItemCode",
                          },
                        ],
                      },
                    allowEditing: false,
                  },
                  {
                    screenField: "SalesUMQty",
                    dataField: "TaxCode",
                    label: "Tax",
                    gridDataField: "TaxCode",
                    allowSearch: false,
                    width: 100,
                  },
                  {
                    screenField: "SalesUMQty",
                    dataField: "SalesUMQty",
                    label: "Qty",
                    gridDataField: "SalesUMQty",
                    editorOptions: {
                      format: "##,###,###,###,##0.00",
                    },
                    allowSearch: false,
                    width: 100,
                  },
                  {
                    dataField: "STDCostTotal",
                    label: "Std Cost",
                    format: "##,###,###,###,##0.00",
                    allowSearch: false,
                    width: 100,
                  },
                  {
                    dataField: "StockUMPrice",
                    label: "List Unit",
                    format: "##,###,###,###,##0.0000",
                    allowSearch: false,
                    width: 100,
                  },
                  {
                    dataField: "LineTotal",
                    label: "List Total",
                    format: "##,###,###,###,##0.00",
                    allowSearch: false,
                    width: 100,
                  },
                  {
                    dataField: "DiscPcnt",
                    label: "Disc %",
                    format: "##,###,###,###,##0.00 '%';(##,###,###,###,##0.00 '%')",
                    allowSearch: false,
                    width: 100,
                  },
                  {
                    dataField: "StockUMNetPrice",
                    label: "Net Unit",
                    format: "##,###,###,###,##0.0000",
                    allowSearch: false,
                    width: 100,
                  },
                  {
                    dataField: "NetLineTotal",
                    label: "Net Total",
                    format: "##,###,###,###,##0.00",
                    allowSearch: false,
                    width: 100,
                  },
                  {
                    dataField: "GPPcnt",
                    label: "Margin",
                    format: "##,###,###,###,##0.00 '%';(##,###,###,###,##0.00 '%')",
                    allowSearch: false,
                    width: 100,
                  },
                ],
              },
            ]
          },
          toolbar: {
            search: true,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: false,
            review: false,
            audit: false
          },
          columns:[],
        },
        footerData: {
          footerItems: this.getFooterItems,
        },        
      }
    },
    getHeaderScreenJson() {
      return {
        headerData: {
          title: {
            primary: {
              primary: {
                dataField: undefined,
                text: `Sales Quote # ${this.baseView.id}`
              },
            },
            secondary: {
              dataField: "CustomerName",
            },
          },
          formItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      dataField: "SalesQuoteCode",
                      allowUpdate: false,
                      label: {
                        text: "Quote #",
                      },
                    },
                    {
                      screenField: "RequiredDate",
                      dataField: "QuoteDate",
                      allowUpdate: false,
                      label: {
                        text: "Quote Date",
                      },
                    },
                    {
                      screenField: "RequiredDate",
                      dataField: "ShipDate",
                      allowUpdate: false,
                      label: {
                        text: "Ship Date",
                      },
                    },
                  ]
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      dataField: "RepName",
                      allowUpdate: false,
                      label: {
                        text: "Rep",
                      },
                    },
                  ]
                }
              ]
            }
          ]
        }
      }
    },
  }
}
</script>
